// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Stories_wrapper__rox1_","carouselDots":"Stories_carouselDots__8BKtS","storiesOuterWrapper":"Stories_storiesOuterWrapper__qEmMb"};